import { memo, FC } from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { setType } from "../../reducers/ViewTypeSlice";
import { FlexBox, HintTooltip } from "@brg/ui";
import ViewTypeShadow from "../../assets/32/ViewTypeShadow";
import ReactTooltip from "react-tooltip";
import { useTranslation } from "react-i18next";
import ViewTypeWide from "../../assets/32/ViewTypeWide";
import { LgSizes18Icon } from "shared/icons/LgSizes18Icon";
import { LgSizes14IconFull } from "shared/icons/LgSizes14IconFull";
import { LgSizes14IconSmall } from "shared/icons/LgSizes14IconSmall";
import { AppTester } from "supporting";

export enum LongreadViewType {
  fluid = 'fluid',
  container = "container",
  shadow = "shadow",
  t_shape = "t-shape",
  fixed_ratio_large = "fixed-ratio-large",
  fixed_ratio_small = "fixed-ratio-small"
}

interface ILRSwitcher {
  vtype?: LongreadViewType;
  currentVType?: LongreadViewType;
  isCGRAVE?: boolean;
}

const LRSwitcher = styled.div<ILRSwitcher>`
  cursor: pointer;
  transition: 0.1s;

  :hover {
    * {
      stroke: ${({isCGRAVE, theme }) => isCGRAVE ? '#ffffff' : theme.projectEdit.label};
    }
  }
  
  * {
    stroke: ${({ currentVType, vtype, isCGRAVE, theme }) => {
      return currentVType === vtype && isCGRAVE ? '#fff' : currentVType === vtype ? theme.viewType.item.active : theme.viewType.item.default
    }};
  }
`;

const LRSwitcherFill = styled.div<ILRSwitcher>`
  cursor: pointer;
  transition: 0.1s;
 
  
  :hover {
    svg > path {
      fill: ${({isCGRAVE, theme }) => isCGRAVE ? '#ffffff' : theme.projectEdit.label};
    }
      mask path {
        stroke: ${({isCGRAVE, theme }) => isCGRAVE ? '#ffffff' : theme.viewType.item.hover};
      }
  }
  
   svg > path {
      fill: ${({ currentVType, vtype, isCGRAVE, theme }) => {
        return currentVType === vtype && isCGRAVE ? '#fff' : currentVType === vtype ? theme.viewType.item.active : theme.viewType.item.default
      }};
      mask path {
        stroke: ${({ currentVType, vtype, isCGRAVE, theme }) => {
          return currentVType === vtype && isCGRAVE ? '#fff' : currentVType === vtype ? theme.viewType.item.active : theme.viewType.item.default
        }};
      }

    }
`;

const ViewTypeControllerRoot = styled(FlexBox)`
  height: 100%;
  align-items: center;
   & > *:not(:last-child) {
    margin-right: 24px;
  }
  & > *{
    z-index: 1;
    }
`;

const ViewTypeController: FC<{ sizesTypes?: boolean }> = ({ sizesTypes }) => {
  const dispatch = useDispatch();
  const vtype = useSelector((state: any) => state.vt.vtype);
  const { t } = useTranslation();
  const isCGRAVE = AppTester.isCGRAVE();
  const isGeo = AppTester.isGeograffee()
  const isSuperPuper = AppTester.isSuperPuper();
  const isGeoDafes = AppTester.isGeoDafes();
  const isHSEDesign = AppTester.isHSEDesign();
  const isContinuumSite = AppTester.isContinuumSite();
  const isGameDeziiign = AppTester.isGameDeziiign();
  const baseStyle = { padding: '2px 8px 4px'};
  const geoStyle =
      (isCGRAVE || isContinuumSite) ?
        { background: "#2C2C2B", color: "#FEFEFE" } 
        : isGeo && !isGeoDafes
        ? { background: "#353A3E" }
        : isGameDeziiign
        ? { background: "#353A3E", color: "#FEFEFE" }
        : isGeoDafes || isHSEDesign
        ? { background: "#E7E7E7", color: "#70706F" }
        : {};

  const combinedStyle = { ...baseStyle, ...geoStyle };

  if (vtype === 'free-type') {
    return null;
  }
  

  if (sizesTypes) {
    return (
      <ViewTypeControllerRoot>
      <LRSwitcherFill
        data-tip={t('project_edit.view_type.t_shape')}
        currentVType={vtype}
        isCGRAVE={isCGRAVE}
        onClick={() => dispatch(setType(LongreadViewType.t_shape))}
        vtype={LongreadViewType.t_shape}>
        <LgSizes18Icon />
      </LRSwitcherFill>
      <LRSwitcher
        data-tip={t('project_edit.view_type.fixed_ratio_large')}
        onClick={() => dispatch(setType(LongreadViewType.fixed_ratio_large))}
        currentVType={vtype}
        vtype={LongreadViewType.fixed_ratio_large}
        isCGRAVE={isCGRAVE}
      >
        <LgSizes14IconFull />
      </LRSwitcher>
      <LRSwitcher
        data-tip={t('project_edit.view_type.fixed_ratio_small')}
        currentVType={vtype}
        isCGRAVE={isCGRAVE}
        onClick={() => dispatch(setType(LongreadViewType.fixed_ratio_small))}
        vtype={LongreadViewType.fixed_ratio_small}>
        <LgSizes14IconSmall />
      </LRSwitcher>
      <ReactTooltip />
    </ViewTypeControllerRoot>
    )
  }


  return (
    <ViewTypeControllerRoot>
      <HintTooltip 
          // @ts-ignore
          customStyle={combinedStyle} noArrow positionY="bottom" z={10000} onWhiteBg={!isGeo && !isSuperPuper} text={t('project_edit.view_type.wide')}>
          <LRSwitcherFill
            data-tip={t('project_edit.view_type.wide')}
            currentVType={vtype}
            isCGRAVE={isCGRAVE}
            onClick={() => dispatch(setType(LongreadViewType.fluid))}
            vtype={LongreadViewType.fluid}>
          <ViewTypeWide />
      </LRSwitcherFill>
      </HintTooltip>
      <HintTooltip 
          // @ts-ignore
          customStyle={combinedStyle} noArrow positionY="bottom" z={10000} onWhiteBg={!isGeo && !isSuperPuper} text={t('project_edit.view_type.regular')}>
          <LRSwitcher
            data-tip={t('project_edit.view_type.regular')}
            onClick={() => dispatch(setType(LongreadViewType.container))}
            currentVType={vtype}
            vtype={LongreadViewType.container}
            isCGRAVE={isCGRAVE}
          >
            
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="6.75" y="3.75" width="18.5" height="24.5" rx="1.25" stroke="#909090" strokeWidth="1.5"/>
            </svg>
                
            
          </LRSwitcher>
      </HintTooltip>
      <HintTooltip 
        // @ts-ignore
        customStyle={combinedStyle} noArrow positionY="bottom" z={10000} onWhiteBg={!isGeo && !isSuperPuper} text={t('project_edit.view_type.shadow')}>
          <LRSwitcher
            data-tip={t('project_edit.view_type.shadow')}
            currentVType={vtype}
            onClick={() => dispatch(setType(LongreadViewType.shadow))}
            isCGRAVE={isCGRAVE}
            vtype={LongreadViewType.shadow}>
              
                  <ViewTypeShadow />
                
            
          </LRSwitcher>
      </HintTooltip>
    </ViewTypeControllerRoot>
  );
};

export default memo(ViewTypeController);
import { memo, FC } from "react";
import styled from "styled-components";
import { useDispatch, useSelector } from "react-redux";
import { setType } from "../../reducers/ViewTypeSlice";
import { FlexBox, HintTooltip } from "@brg/ui";
import ViewTypeShadow from "../../assets/32/ViewTypeShadow";
import ReactTooltip from "react-tooltip";
import { useTranslation } from "react-i18next";
import ViewTypeWide from "../../assets/32/ViewTypeWide";
import { LgSizes18Icon } from "shared/icons/LgSizes18Icon";
import { LgSizes14IconFull } from "shared/icons/LgSizes14IconFull";
import { LgSizes14IconSmall } from "shared/icons/LgSizes14IconSmall";
import { AppTester } from "supporting";

export enum LongreadViewType {
  fluid = 'fluid',
  container = "container",
  shadow = "shadow",
  t_shape = "t-shape",
  fixed_ratio_large = "fixed-ratio-large",
  fixed_ratio_small = "fixed-ratio-small"
}

interface ILRSwitcher {
  vtype?: LongreadViewType;
  currentVType?: LongreadViewType;
  isCGRAVE?: boolean;
}

const LRSwitcher = styled.div<ILRSwitcher>`
  cursor: pointer;
  transition: 0.1s;

  :hover {
    * {
      stroke: ${({isCGRAVE, theme }) => isCGRAVE ? '#ffffff' : theme.projectEdit.label};
    }
  }
  
  * {
    stroke: ${({ currentVType, vtype, isCGRAVE, theme }) => {
      return currentVType === vtype && isCGRAVE ? '#fff' : currentVType === vtype ? theme.viewType.item.active : theme.viewType.item.default
    }};
  }
`;

const LRSwitcherFill = styled.div<ILRSwitcher>`
  cursor: pointer;
  transition: 0.1s;
 
  
  :hover {
    svg > path {
      fill: ${({isCGRAVE, theme }) => isCGRAVE ? '#ffffff' : theme.projectEdit.label};
    }
      mask path {
        stroke: ${({isCGRAVE, theme }) => isCGRAVE ? '#ffffff' : theme.viewType.item.hover};
      }
  }
  
   svg > path {
      fill: ${({ currentVType, vtype, isCGRAVE, theme }) => {
        return currentVType === vtype && isCGRAVE ? '#fff' : currentVType === vtype ? theme.viewType.item.active : theme.viewType.item.default
      }};
      mask path {
        stroke: ${({ currentVType, vtype, isCGRAVE, theme }) => {
          return currentVType === vtype && isCGRAVE ? '#fff' : currentVType === vtype ? theme.viewType.item.active : theme.viewType.item.default
        }};
      }

    }
`;

const ViewTypeControllerRoot = styled(FlexBox)`
  height: 100%;
  align-items: center;
   & > *:not(:last-child) {
    margin-right: 24px;
  }
  & > *{
    z-index: 1;
    }
`;

const ViewTypeController: FC<{ sizesTypes?: boolean }> = ({ sizesTypes }) => {
  const dispatch = useDispatch();
  const vtype = useSelector((state: any) => state.vt.vtype);
  const { t } = useTranslation();
  const isCGRAVE = AppTester.isCGRAVE();
  const isGeo = AppTester.isGeograffee()
  const isSuperPuper = AppTester.isSuperPuper();
  const isGeoDafes = AppTester.isGeoDafes();
  const isHSEDesign = AppTester.isHSEDesign();
  const isContinuumSite = AppTester.isContinuumSite();
  const isGameDeziiign = AppTester.isGameDeziiign();
  const baseStyle = { padding: '2px 8px 4px'};
  const geoStyle =
      (isCGRAVE || isContinuumSite) ?
        { background: "#2C2C2B", color: "#FEFEFE" } 
        : isGeo && !isGeoDafes
        ? { background: "#353A3E" }
        : isGameDeziiign
        ? { background: "#353A3E", color: "#FEFEFE" }
        : isGeoDafes || isHSEDesign
        ? { background: "#E7E7E7", color: "#70706F" }
        : {};

  const combinedStyle = { ...baseStyle, ...geoStyle };

  if (vtype === 'free-type') {
    return null;
  }
  

  if (sizesTypes) {
    return (
      <ViewTypeControllerRoot>
      <LRSwitcherFill
        data-tip={t('project_edit.view_type.t_shape')}
        currentVType={vtype}
        isCGRAVE={isCGRAVE}
        onClick={() => dispatch(setType(LongreadViewType.t_shape))}
        vtype={LongreadViewType.t_shape}>
        <LgSizes18Icon />
      </LRSwitcherFill>
      <LRSwitcher
        data-tip={t('project_edit.view_type.fixed_ratio_large')}
        onClick={() => dispatch(setType(LongreadViewType.fixed_ratio_large))}
        currentVType={vtype}
        vtype={LongreadViewType.fixed_ratio_large}
        isCGRAVE={isCGRAVE}
      >
        <LgSizes14IconFull />
      </LRSwitcher>
      <LRSwitcher
        data-tip={t('project_edit.view_type.fixed_ratio_small')}
        currentVType={vtype}
        isCGRAVE={isCGRAVE}
        onClick={() => dispatch(setType(LongreadViewType.fixed_ratio_small))}
        vtype={LongreadViewType.fixed_ratio_small}>
        <LgSizes14IconSmall />
      </LRSwitcher>
      <ReactTooltip />
    </ViewTypeControllerRoot>
    )
  }


  return (
    <ViewTypeControllerRoot>
      <HintTooltip 
          // @ts-ignore
          customStyle={combinedStyle} noArrow positionY="bottom" z={10000} onWhiteBg={!isGeo && !isSuperPuper} text={t('project_edit.view_type.wide')}>
          <LRSwitcherFill
            data-tip={t('project_edit.view_type.wide')}
            currentVType={vtype}
            isCGRAVE={isCGRAVE}
            onClick={() => dispatch(setType(LongreadViewType.fluid))}
            vtype={LongreadViewType.fluid}>
          <ViewTypeWide />
      </LRSwitcherFill>
      </HintTooltip>
      <HintTooltip 
          // @ts-ignore
          customStyle={combinedStyle} noArrow positionY="bottom" z={10000} onWhiteBg={!isGeo && !isSuperPuper} text={t('project_edit.view_type.regular')}>
          <LRSwitcher
            data-tip={t('project_edit.view_type.regular')}
            onClick={() => dispatch(setType(LongreadViewType.container))}
            currentVType={vtype}
            vtype={LongreadViewType.container}
            isCGRAVE={isCGRAVE}
          >
            
                  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="6.75" y="3.75" width="18.5" height="24.5" rx="1.25" stroke="#909090" strokeWidth="1.5"/>
            </svg>
                
            
          </LRSwitcher>
      </HintTooltip>
      <HintTooltip 
        // @ts-ignore
        customStyle={combinedStyle} noArrow positionY="bottom" z={10000} onWhiteBg={!isGeo && !isSuperPuper} text={t('project_edit.view_type.shadow')}>
          <LRSwitcher
            data-tip={t('project_edit.view_type.shadow')}
            currentVType={vtype}
            onClick={() => dispatch(setType(LongreadViewType.shadow))}
            isCGRAVE={isCGRAVE}
            vtype={LongreadViewType.shadow}>
              
                  <ViewTypeShadow />
                
            
          </LRSwitcher>
      </HintTooltip>
    </ViewTypeControllerRoot>
  );
};

export default memo(ViewTypeController);
